import { parse as parseCookie } from 'cookie';
import { API_HOST, API_PREFIX, X_CSRF_COOKIE, X_CSRF_TOKEN } from './apiPaths';

export const postLogin = async (body: any): Promise<undefined | true> => {
    try {
        const cookies = parseCookie(document.cookie);
        const response = await fetch(API_HOST + API_PREFIX + '/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Content': 'application/json',
                [X_CSRF_TOKEN]: cookies[X_CSRF_COOKIE],
            } as HeadersInit,
            body: JSON.stringify(body),
        });

        if (response.redirected) {
            // @ts-ignore
            window.location = response.url.includes('/logistics') ? response.url : '/logistics';
        }

        if (!response.ok) {
            return;
        }

        return true;
    } catch {
        return;
    }
};
